import React, { useEffect, useState, useRef } from "react";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";
import { Grid, Typography, CircularProgress } from "@material-ui/core";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import { MenuItem, Select, Hidden } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { usageService } from "../model/e_service";
import { store } from "../../../../helpers/store";
import { DatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import ChartTest from '../view/e_co2_emission_chart';
import { Co2EmissionConstants } from "../model/e_constants";
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { useTranslation } from "react-i18next";

export const STYLED_SELECT = withStyles((theme) => ({
  root: {
    color: theme.palette.ePrimary?.base + " !important",
    fontSize: "0.8rem",
    border: "0.1rem solid " + theme.palette.eLight?.base + " !important",
    borderRadius: "0.25rem",
    padding: "0.375rem 0.65rem",
  },
  select: {
    "&:focus": {
      borderRadius: "0.25rem",
    },
    whiteSpace: "nowrap",
  },
  icon: {
    color: theme.palette.ePrimary?.base + " !important",
  },
}))(Select);

export const STYLED_MENU_ITEM = withStyles((theme) => ({
  root: {
    justifyContent: "flex-start !important",
    color: theme.palette.ePrimary?.base + " !important",
    fontSize: "medium",
    "&:hover": {
      backgroundColor: theme.palette.eLight?.hover,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.ePrimary?.hover,
      },
    },
    "&:focus": {
      backgroundColor: theme.palette.eLight?.base,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.ePrimary?.base,
      },
    },
  },
}))(MenuItem);

const useStyle = makeStyles((theme) => ({
  mobileDropdown: {
    width: "15vh",
  },
  title:{
    color:theme.palette.ePrimary?.base
  },
  dropDownLabel:{
      marginRight:10,
  },
  calendar:{
    border: "1px solid " + theme.palette.eLight?.base + " !important",
    borderRadius: "0.25rem",
    paddingLeft: '1rem',
    justifyContent: "flex-start !important",
    fontSize: "0.8rem",
    width: 70,
  },
  error:{
    width :"-webkit-fill-available",
    height :"6vh",
    color:  theme.palette.eLight?.base,
  },
  errorMsg:{
    color:  theme.palette.ePrimary?.base,
  },
  yearColor:{
    fontSize:"medium !important",
    color :theme.palette.ePrimary?.base,
  },
  fullHeight: {
    height: "100%"
  },
  mainGrid: {
    height: "100%",
    flexFlow: "column",
    width: "100%"
  },
  graphGrid: {
    flexGrow: 1,
    width: "100%"
  }
}));

export default function ChooseDropdown() {
  const classes = useStyle();
  const [records, setRecords] = useState(null);
  const [datePickerIsOpen, setDatePickerIsOpen] = React.useState(false);
  const [selectedYear, setSelectedYear] =useState(new Date())
  const languageCode = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const isTabletOrMobile = useMediaQuery({ maxWidth: 300 });
  const [choosetimePeriodDropdown, setChoosetimePeriod] = useState(null);
  const saId = useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
  const saStartDate= useSelector((state) => state?.meterDetails?.getSaInfo?.saStartDate);
  const accountId = useSelector((state) => state?.meterDetails?.accountId);
  const [usageData, setUsageData] = useState(null);
  const {t:label, ready: labelReady} = useTranslation("label-E_CO2_EMISSION_REPORT");
  const usageStoreData = useSelector((store) => store?.UsageGraphData?.data);
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  let backendDataFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT
  );
  let backendYearFormat = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.YEAR_ONLY_FORMAT
  );
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  const graphGridRef = useRef();

  const getGridSize = () => {
    setWidth(graphGridRef.current.clientWidth);
    setHeight(graphGridRef.current.clientHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", getGridSize);
    return () => window.removeEventListener("resize", getGridSize);
  }, []);

  useEffect(() => {    
    getGridSize();
  },[usageData])

  const ddlMenuProps = {
    disableScrollLock: false,
    anchorOrigin: {
      vertical: "bottom",
    },
    transformOrigin: {
      vertical: "top",
    },
    getContentAnchorEl: null,
  };
  useEffect(() => {
    if(accountId && saId){
      usageService
      .getDropdownData(Co2EmissionConstants?.E_CO2_EMISSION_REPORT_DROPDOWN,languageCode)
      .then((resp) => {
        setRecords(resp.data.getDropdownData);
        setChoosetimePeriod(resp.data.getDropdownData[0]);
      });
    }
  }, [languageCode,accountId,saId]);
  useEffect(() => {
    let endDate = moment().endOf("year").format("YYYY-MM-DD");
    let startDate = moment().startOf("year").format("YYYY-MM-DD");
    setStartDate(startDate)
    setEndDate(endDate)
    store.getState().snackbar = true;
    if(accountId && saId){
      usageService
      .usageGraphData(saId, accountId, startDate, endDate, Co2EmissionConstants?.D2BM,Co2EmissionConstants?.CO2_EMISSION)
      .then((response) => {
        store.getState().snackbar = false;
        setUsageData(response.data);
      });
    }
  }, [saId,accountId]);
  
  const timePeriodChange = (event) => {
    setChoosetimePeriod({
      dropDownCode: event.target.value,
      dropDownValue: event.target.name,
    });
    if (event.target.value === Co2EmissionConstants?.E_CO2_EMISSION_REPORT_MONTHLY) {
      let endDate = moment(selectedYear).endOf('year').format(backendDataFormat);
      let startDate = moment(selectedYear).startOf('year').format(backendDataFormat);
      setStartDate(startDate)
      setEndDate(endDate)
      store.getState().snackbar = true;
      usageService
        .usageGraphData(saId, accountId, startDate, endDate, Co2EmissionConstants?.D2BM,Co2EmissionConstants?.CO2_EMISSION)
        .then((response) => {
          store.getState().snackbar = false;
          setUsageData(response.data);
        });   
    } else if (
      event.target.value === Co2EmissionConstants?.E_CO2_EMISSION_REPORT_QUARTERLY
    ) {
       let endDate = moment(selectedYear).endOf("year").format(backendDataFormat);
       let startDate = moment(selectedYear).startOf("year").format(backendDataFormat);
      setStartDate(startDate)
      setEndDate(endDate)
      store.getState().snackbar = true;
      usageService
        .usageGraphData(saId, accountId, startDate, endDate, Co2EmissionConstants?.D2BQ,Co2EmissionConstants?.CO2_EMISSION)
        .then((response) => {
          store.getState().snackbar = false;
          setUsageData(response.data);
        });
    }
  }
  useEffect(() => {
    if(accountId && saId){
      setUsageData(usageStoreData);
    }
  }, [usageStoreData,accountId,saId]);

  const closePicker=()=>{
    setDatePickerIsOpen(false);
  }

    const filterPeriod = (startDate,endDate) => {
      if(accountId && saId){
        if (choosetimePeriodDropdown?.dropDownCode === Co2EmissionConstants?.E_CO2_EMISSION_REPORT_MONTHLY) {
          store.getState().snackbar = true;
          usageService
            .usageGraphData(saId, accountId, startDate, endDate, Co2EmissionConstants?.D2BM,Co2EmissionConstants?.CO2_EMISSION)
            .then((response) => {
              store.getState().snackbar = false;
              setUsageData(response.data);
            });   
        } else if (
          choosetimePeriodDropdown?.dropDownCode === Co2EmissionConstants?.E_CO2_EMISSION_REPORT_QUARTERLY
        ) {
          store.getState().snackbar = true;
          usageService
            .usageGraphData(saId, accountId, startDate, endDate, Co2EmissionConstants?.D2BQ,Co2EmissionConstants?.CO2_EMISSION)
            .then((response) => {
              store.getState().snackbar = false;
              setUsageData(response.data);
            });
        }
      }
   }
   const handleMonthPeriod = (event) => {
    setSelectedYear(moment(event).format(backendYearFormat))
    let endDate = (event);
    let startDate = (event);
    filterPeriod(moment(startDate).startOf('year').format(backendDataFormat),moment(endDate).endOf('year').format(backendDataFormat));
  };
  const subscriptTitle = (title) => {
    if(title){
      let isMatchFound = title.match(/\d/);
      let [beforeSubscript, afterSubscript] = title?.split(/\d/)
      return(
        <>
          {beforeSubscript}<sub>{isMatchFound && title.match(/\d/).toString()}</sub> {afterSubscript}
        </>
      )
    }
  }
  return (
    <Grid container className={classes.mainGrid}>
      <Grid item container direction='row'>
        <Grid item md={12} sm={12}>
        {
          labelReady ?
          <Typography
            variant="h6"
            className={classes.title}
            align="left" >
            <b>{subscriptTitle(label("E_CO2_EMISSION_REPORT_TITLE"))}</b>
          </Typography>
          : <Skeleton />
        }
        </Grid>
      </Grid>
      <Grid item container justify='left' spacing={2}>
        <Grid item  >
        {
          labelReady ?
          <Typography variant="subtitle2" className={classes.dropDownLabel}>{label("E_CO2_EMISSION_REPORT_YEAR")}</Typography>
          : <Skeleton />
        }
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
              <DatePicker
                className={isTabletOrMobile ? classes.mobileCalendar : classes.calendar}
                disableFuture
                value={selectedYear}
                openTo="year"
                InputProps={{ disableUnderline: true, classes: { root: classes.yearColor } }}
                maxDate={moment()}
                minDate={moment(saStartDate).startOf('year').format("YYYY-MM-DD")}
                cancelLabel={<span onClick={closePicker}>{labelReady && label("E_CANCEL")}</span>}
                views={["year"]}
                onChange={handleMonthPeriod}
                IconComponent={ExpandMoreSharpIcon}
              />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item>
          {choosetimePeriodDropdown ? (
            <>
            {
              labelReady ?
              <Typography variant="subtitle2" className={classes.dropDownLabel}>{label("E_CO2_EMISSION_REPORT_CHOOSE_VIEW")}</Typography>
              : <Skeleton />
            }
              <STYLED_SELECT
                name={choosetimePeriodDropdown?.dropDownValue}
                value={choosetimePeriodDropdown?.dropDownCode}
                onChange={timePeriodChange}
                displayEmpty={true}
                IconComponent={ExpandMoreSharpIcon}
                disableUnderline={true}
                MenuProps={ddlMenuProps}
                className={isTabletOrMobile ? classes.mobileDropdown : ""}
              >
                {records &&
                  records.map((i) => (
                    <STYLED_MENU_ITEM
                      value={i.dropDownCode}
                      className="text-field"
                      key={i.dropDownCode}
                    >
                      {i.dropDownValue}
                    </STYLED_MENU_ITEM>
                  ))}
              </STYLED_SELECT>
            </>
          ) : (
            <Skeleton />
          )}{" "}
        </Grid>
      </Grid>
      <Grid
        ref={graphGridRef}
        item
        justify="center"
        alignItems="center"
        container
        className={classes.graphGrid}
      >
        {usageData ? (
            <ChartTest
             data={usageData?.getUsageTrends?.usageQuantity}
             labels={label}
             labelReady={labelReady}
             width={width}
             height={height}
            />
        ) :
          (<>
            <Grid align="center" justify="center"><ReportProblemOutlinedIcon className={classes.error} /></Grid>
            <Grid contianer justify="center">
              <Grid item>
              {
                labelReady ?
                <Typography align="center" className={classes.errorMsg} variant="subtitle1">{label("E_NO_RECORDS")}</Typography>
                : <Skeleton />
              }
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
}